import { useCallback } from "react";
import type { ToTarget } from "../../to/use-to-target";
import type { MergeTagV2 } from "../types";
import { groupTags as groupTagsFn, sortTags } from "../util";
import type { TagGroup } from "./types";

export const useFilterTags = (
  tags: MergeTagV2[],
  toTarget: ToTarget,
): ((x: string) => TagGroup) => {
  return useCallback((searchValue) => filterTagFn(tags, toTarget, searchValue), [tags, toTarget]);
};

export function filterTagFn(tags: MergeTagV2[], toTarget: ToTarget, searchValue: string): TagGroup {
  const groupedTags = groupTagsFn(tags, toTarget);

  return Object.entries(groupedTags).reduce((acc, [key, { title, subtitle, groupTags }]) => {
    const section = key;
    // nosemgrep: javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp
    const searchRegex = new RegExp(searchValue.replace(/\s+/g, " ").toLowerCase(), "i");
    // NB for display names, the search will only exactly match if there is a single space between words (as there should be)
    acc[section] = {
      title,
      subtitle,
      groupTags: sortTags(
        searchValue
          ? groupTags.filter(
              (tag) =>
                searchRegex.test(tag.field_name) ||
                searchRegex.test(key) ||
                searchRegex.test(`${key}.`) ||
                searchRegex.test(tag.id),
            )
          : groupTags,
        ["recipient", "subject"].includes(section) ? (key as "recipient" | "subject") : undefined,
        searchValue,
      ),
    };
    return acc;
  }, {} as TagGroup);
}
